<template>
  <div>
    <vue-apex-charts
      v-if="series.length > 0"
      type="bar"
      :height="heightSize"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ColumnChart',
  components: {
    VueApexCharts,
  },
  props: {
    heightSize: {
      // eslint-disable-next-line no-bitwise,vue/require-prop-type-constructor
      type: (String | Number),
      default: 350,
    },
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '65%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'İşlem Tutarı ₺',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter(val) {
              if (typeof Number(val) !== 'number') {
                return val
              }
              const formatter = new Intl.NumberFormat('tr-TR', {
                minimumFractionDigits: 2,
              })
              return `${formatter.format(val)}₺`
            },
          },
        },
      },
    }
  },
  watch: {
    seriesData: {
      deep: true,
      handler(val) {
        this.series = val
      },
    },
    categoriesData: {
      deep: true,
      handler(val) {
        this.chartOptions.labels = val
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            xaxis: {
              categories: val,
            },
          },
        }
      },
    },
  },
  mounted() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.labels = this.categoriesData
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            categories: this.categoriesData,
          },
        },
      }
    },
  },
}
</script>
